import React, { useState, useRef } from "react";
import MenuBar from "../components/menuBarLoggedIn/menuBarLoggedOutNoNavbar";
import "../styles/searchPage.css";
import locationVector from "../assets/svgs/location-green.svg"
import destinationVector from "../assets/svgs/destination.svg"
import calenderVector from "../assets/svgs/calender.svg"
import downChevronVector from "../assets/svgs/down-chevron.svg"
import plusVector from "../assets/svgs/plus-pc.svg"
import anonymousVector from "../assets/svgs/person.svg"
import checkTick from "../assets/svgs/check-tick.svg"
import emptyStar from "../assets/svgs/star-empty.svg"
import filledStar from "../assets/svgs/star-filled.svg"



import AEC from "../assets/images/company-ticket-logos/AEC transport.png"
import chisco from "../assets/images/company-ticket-logos/chisco.png"
import guo from "../assets/images/company-ticket-logos/Guo transport.png"
import gltl from "../assets/images/company-ticket-logos/gltl.png"


const SearchPage = () => {
    const [price, setPrice] = useState(0);

    var today = new Date();
    const yyyy = today.getFullYear();
    let mm = today.getMonth() + 1; // Months start at 0!
    let dd = today.getDate();

    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;
    var currentDate =  dd + ' - ' + mm + ' - ' + yyyy;

    const [date, setDate] = useState(currentDate);
    const amtRangeRef = useRef(null);
    
    // 👇️ called every time input's value changes
    const handlePriceChange = event => {
        // const amtRange = amtRangeRef.target;
        // event.target.style.backgroundSize = (price - event.target.min) * 100 / (event.target.max - event.target.min) + '% 100%'
        // event.target.style.backgroundSize = (event.target.value - event.target.min) * 100 / (event.target.max - event.target.min) + '% 100%'
        event.target.style.backgroundSize = (event.target.value - event.target.min) * 100 / (event.target.max - event.target.min) + '% 100%'
        setPrice(event.target.value);
        event.target.style.backgroundSize = (event.target.value - event.target.min) * 100 / (event.target.max - event.target.min) + '% 100%'
    };
    const handleDateChange = event => {
            setDate(event.target.value);
            // Reset the value so the picker always
            // opens in a fresh state regardless of
            // what was last picked
            event.target.value = '';
          };
    return (
      <>
        <MenuBar/>
        <header className="search-details">
            <div className="search-details-wrapper">
                <form action="" method="post">
                    <div className="location">
                        <img src={locationVector} alt="location" />
                        <input type="text" value={"Lagos, Ikeja"} spellcheck="false"/>
                    </div>
                    <div className="destination">
                        <img src={destinationVector} alt="destination" />
                        <input type="text" value={"Abuja, Wuse 2"} spellcheck="false"/>
                    </div>
                    <div className="search-details-divider"></div>
                    <div className="current-and-return-dates">
                        <div className="current-date">
                            <div className="date-toggle">
                                <img src={calenderVector} alt="calender" />
                                <input type="date" name="date-picker-input" id="date-picker-input" value={date} onChange={handleDateChange} />
                            </div>
                            <input type="text" name="date-picker-text" id="date-picker-text" value={date} onChange={handleDateChange} />
                        </div>
                        <div className="return-date">
                            <input type="date" />
                            <div className="return-date-cover">
                                <img src={plusVector} alt="add date" />
                                <p>Add return date</p>
                            </div>
                            </div>
                    </div>
                    <div className="passengers">
                        <input type="text" value={"1 passenger (adult)"}/>
                        <div className="dwn-chev-wrapper">
                            <img src={downChevronVector} alt="" />
                        </div>
                    </div>
                    <button type="submit">Search</button>
                </form>
            </div>
        </header>
        <main className="search-main">
            <div className="search-main-wrapper">
                <aside className="search-filter-aside">
                    <div className="price-range">
                        <label htmlFor="amountInput">Price Range</label>
                        <div className="price-range-input">
                            <input type="range" name="amountRange" id="amountRange" min="0" max="50000" value={price} ref={amtRangeRef} onChange={handlePriceChange} />
                            <input type="number" name="amountInput" id="amountNumber" min="0" max="50000" value={price} onChange={handlePriceChange} />
                        </div>
                    </div>
                    <div className="comfort-type">
                        <label>Comfort type</label>
                        <div className="comfort-type-input">
                            <label htmlFor="food">
                                <input type="checkbox" name="" id="food" value={"food"}/>
                                <span class="checkmark"><img src={checkTick} alt="" /></span>
                                Food
                            </label>
                            <label htmlFor="toilet">
                                <input type="checkbox" name="toilet" id="toilet" value={"toilet"}/>
                                <span class="checkmark"><img src={checkTick} alt="" /></span>
                                Toilet
                            </label>
                            <label htmlFor="ac">
                                <input type="checkbox" name="ac" id="ac" value={"ac"}/>
                                <span class="checkmark"><img src={checkTick} alt="" /></span>
                                Air-Conditioner (AC)
                            </label>
                        </div>
                    </div>
                    <div className="transport-companies">
                        <label>Transport companies</label>
                        <div className="transport-companies-input">
                            <input type="text" name="" id="" value={"All transport companies"}/>
                            <img src={downChevronVector} alt="" />
                        </div>
                    </div>
                    <div className="user-ratings">
                        <label>Based on user ratings</label>
                        <div className="user-ratings-input">
                            <input type="radio" name="user-rating" id="five-rating" value="5"/>
                            <label htmlFor="five-rating"></label>
                            <input type="radio" name="user-rating" id="four-rating" value="4"/>
                            <label htmlFor="four-rating"></label>
                            <input type="radio" name="user-rating" id="three-rating" value="3"/>
                            <label htmlFor="three-rating"></label>
                            <input type="radio" name="user-rating" id="two-rating" value="2"/>
                            <label htmlFor="two-rating"></label>
                            <input type="radio" name="user-rating" id="one-rating" value="1"/>
                            <label htmlFor="one-rating"></label>
                        </div>
                    </div>

                </aside>
                <section className="ticket-selection">
                    <div className="search-filter-buttons">
                        <button>Earliest</button>
                        <button>Cheapest</button>
                        <button>Fastest</button>
                    </div>
                    <div className="tickets">
                        <a className="ticket" href="/ticket-option">
                            <div className="ticket-logo">
                                <img src={AEC} alt="AEC transport" />
                            </div>
                            <div className="ticket-details">
                                <div className="departure-details">
                                    <div className="time-of-departure">10:00 am</div>
                                    <div className="venue-of-departure">Lagos, Ajah</div>
                                    <div className="date-of-departure">Fri, April 13</div>
                                </div>
                                <div className="available-seats">
                                    12 seats left
                                </div>
                                <div className="arrival-details">
                                    <div className="time-of-arrival">6:00 pm</div>
                                    <div className="venue-of-arrival">Abuja, Wuse 2</div>
                                    <div className="date-of-arrival">Fri April 13</div>
                                </div>
                            </div>
                            <div className="requirement-details">
                                <div className="financial-requirement">
                                    <p>&#8358; 13,000</p>
                                </div>
                                <div className="passenger-requirement">
                                    <img src={anonymousVector} alt="" />
                                    <p>1 passenger</p>
                                </div>
                            </div>
                        </a>
                        <div className="ticket">
                            <div className="ticket-logo">
                                <img src={chisco} alt="chisco transport" />
                            </div>
                            <div className="ticket-details">
                                <div className="departure-details">
                                    <div className="time-of-departure">6:00 am</div>
                                    <div className="venue-of-departure">Lagos, Ajah</div>
                                    <div className="date-of-departure">Fri, April 13</div>
                                </div>
                                <div className="available-seats">
                                    10 seats left
                                </div>
                                <div className="arrival-details">
                                    <div className="time-of-arrival">8:00 pm</div>
                                    <div className="venue-of-arrival">Abuja, Wuse 2</div>
                                    <div className="date-of-arrival">Fri April 13</div>
                                </div>
                            </div>
                            <div className="requirement-details">
                                <div className="financial-requirement">
                                    <p>&#8358; 3,000</p>
                                </div>
                                <div className="passenger-requirement">
                                    <img src={anonymousVector} alt="" />
                                    <p>1 passenger</p>
                                </div>
                            </div>
                        </div>
                        <div className="ticket">
                            <div className="ticket-logo">
                                <img src={guo} alt="AEC transport" />
                            </div>
                            <div className="ticket-details">
                                <div className="departure-details">
                                    <div className="time-of-departure">11:00 am</div>
                                    <div className="venue-of-departure">Lagos, Ajah</div>
                                    <div className="date-of-departure">Fri, April 13</div>
                                </div>
                                <div className="available-seats">
                                    5 seats left
                                </div>
                                <div className="arrival-details">
                                    <div className="time-of-arrival">10:00 pm</div>
                                    <div className="venue-of-arrival">Abuja, Wuse 2</div>
                                    <div className="date-of-arrival">Fri April 13</div>
                                </div>
                            </div>
                            <div className="requirement-details">
                                <div className="financial-requirement">
                                    <p>&#8358; 5,000</p>
                                </div>
                                <div className="passenger-requirement">
                                    <img src={anonymousVector} alt="" />
                                    <p>1 passenger</p>
                                </div>
                            </div>
                        </div>
                        <div className="ticket">
                            <div className="ticket-logo">
                                <img src={gltl} alt="AEC transport" />
                            </div>
                            <div className="ticket-details">
                                <div className="departure-details">
                                    <div className="time-of-departure">10:00 am</div>
                                    <div className="venue-of-departure">Lagos, Ajah</div>
                                    <div className="date-of-departure">Fri, April 13</div>
                                </div>
                                <div className="available-seats">
                                    12 seats left
                                </div>
                                <div className="arrival-details">
                                    <div className="time-of-arrival">6:00 pm</div>
                                    <div className="venue-of-arrival">Abuja, Wuse 2</div>
                                    <div className="date-of-arrival">Fri April 13</div>
                                </div>
                            </div>
                            <div className="requirement-details">
                                <div className="financial-requirement">
                                    <p>&#8358; 13,000</p>
                                </div>
                                <div className="passenger-requirement">
                                    <img src={anonymousVector} alt="" />
                                    <p>1 passenger</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </main>
      </>
  );
};
export default SearchPage;